
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RequestKeyPage',
  data(): {
    email: string;
    phone: string;
  } {
    return {
      email: '',
      phone: ''
    };
  }
});
